<template>
	<div>
		<transition name="fade">
			<Row v-if="mainTable.sarchCardShow" :gutter="16">
				<Col span="24">
				<search-card :form="mainTable.searchForm" :table-load-event="getMyCompensationList"
					:table-search="mainTable.tableSearch" />
				</Col>
			</Row>
		</transition>

		<Card>
			<Row :gutter="16">
				<Col span="24">
				<div class="global-tool-bar">
					<div class="left-bar">
						<span class="title">退款单</span>
						<RadioGroup v-model="userType" style="margin-left:4px;" @on-change="onUserTypeChage">
							<Radio label="F"> <span>外部会员</span></Radio>
							<Radio label="E"> <span>内部会员</span></Radio>
						</RadioGroup>
					</div>
					<div class="right-bar">
						<Button v-show="isShowOrNot" size="small" v-if="this.$checkAccessArray(['G'])" class="btns"
							shape="circle" type="success" icon="ios-add-circle-outline"
							@click="onCompesationCreate">新增</Button>
						<Button type="primary" size="small" class="btns" shape="circle" icon="ios-search"
							@click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
						<Button type="info" size='small' class="btns" shape="circle" icon="ios-send"
							@click="onExportShow=true">导出</Button>
					</div>
				</div>
				</Col>
			</Row>

			<Row :gutter="16">
				<Col span="24">
				<stand-pagination-table :columns="mainTable.columns" :data="mainTable.data" :loading="mainTable.loading"
					:table-search="mainTable.tableSearch" :table-load-event="getMyCompensationList" />
				</Col>
			</Row>
		</Card>
		<Modal v-model="onExportShow" title="选择导出方式" class-name="vertical-center-modal" width="400"
			@on-cancel="onExportShow=false" @on-ok="onExport">		
				<RadioGroup v-model="onExportType" type="button" style="margin-left: 100px;">
					<Radio label="明细导出" border></Radio>
					<Radio label="汇总导出" border></Radio>
				</RadioGroup>
		</Modal>

		<Modal v-model="compenstationModal.show" :title="compenstationModal.isCreated?'新增退款单':'查看退款单'"
			class-name="vertical-center-modal" width="800" @on-cancel="onCompensationcancel">
			<Spin v-if="innerSpin" size="large" fix></Spin>
			<Form label-position="top" ref="compenstationModal" :model="compenstationModal" :rules="ruleValidate">
				<Row :gutter="16">
					<Col span="8">
					<FormItem label="发货单号">
						<Input v-model="compenstationModal.compensationRecordRelateRecordCode" search enter-button
							placeholder="输入发货单号，点击搜索.." @on-search="onSearchOrder(1)">
						</Input>
					</FormItem>
					</Col>
					<Col span="8">
					<FormItem label="客户名称">
						<Input readonly v-model="compenstationModal.userPersonName"></Input>
					</FormItem>
					</Col>
					<Col span="8">
					<FormItem label="定单金额">
						<Input readonly v-model="compenstationModal.totalOrderCost"></Input>
					</FormItem>
					</Col>
					<Col span="8">
					<FormItem label="退款类型" prop="compensationRecordType">
						<Select v-model="compenstationModal.compensationRecordType">
							<Option v-for="item in COMPENSATION_TYPE_OPTIONS" :key="item.value" :value="item.value">{{
								item.label }}</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span="8">
					<FormItem label="退款方">
						<Input readonly value="苗场"></Input>
					</FormItem>
					</Col>
					<Col span="8">
					<FormItem label="被退款方">
						<Input readonly value="客户"></Input>
					</FormItem>
					</Col>
					<Col span="8">
					<FormItem label="状态" prop="status">
						<Input readonly v-model="compenstationModal.status"></Input>
					</FormItem>
					</Col>
					<Col span="16" v-if="compenstationModal.status=='撤销'">
					<FormItem label="撤销原因:" prop="cancelReason">
						<Input readonly v-model="compenstationModal.cancelReason" type="textarea"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row v-if="this.compenstationModal.complains.length>0" :gutter="16">
					<Col span="12">
					<FormItem label="售后列表详细描述">
						<Input readonly :value="this.compenstationModal.complains.map(x=>x.complainInfo).join(';\n')"
							type="textarea"></Input>
					</FormItem>
					</Col>
					<Col span="12">
					<FormItem label="售后列表回复">
						<Input readonly
							:value="this.compenstationModal.complains.map(x=>x.complainResponse).join(';\n')"
							type="textarea"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="16">
					<Col span="8">
					<FormItem label="凭证" prop="voucherFile">
						<FileUpload :key="timer" v-model="compenstationModal.voucherFile" :mode="mode"></FileUpload>
					</FormItem>
					</Col>
					<Col span="16">
					<FormItem label="备注"  prop="remark">
						<Input v-model="compenstationModal.remark" type="textarea"></Input>
					</FormItem>
					</Col>
				</Row>
			</Form>
			<Row :gutter="16">
				<Col span="24">
				<Table size="small" :columns="productTable.columns" :data="productTable.data"
					:loading="productTable.loading" highlight-row stripe border />
				</Col>
			</Row>
			<div slot="footer">
				<span
					style="color:red;font-size:20px;margin-right:40px;">共计退款:{{numberToFixed(compenstationModal.totalValue,2)}}</span>
				<Button v-if="canAdd" type="primary" @click="onCompensationSave">确认</Button>
				<Button type="error" @click="onCompensationcancel">取消</Button>
			</div>
		</Modal>

		<Modal v-model="cancelModel.show" title="撤销退款单" class-name="vertical-center-modal" width="800">
			<Spin v-if="innerSpin" size="large" fix></Spin>
			<Form label-position="top" ref="cancelModel" :model="cancelModel">
				<Row :gutter="16">
					<Col span="24">
					<FormItem label="填写撤销原因:" prop="cancelReason">
						<Input v-model="cancelModel.cancelReason" type="textarea" placeholder="请填写撤销当前退款单的原因"></Input>
					</FormItem>
					</Col>
				</Row>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="onCancelSave">确认撤销</Button>
				<Button type="error" @click="onClose">取消</Button>
			</div>
		</Modal>

		<Modal v-model="approveModel.show" title="审核退款单" class-name="vertical-center-modal" width="800">
			<Spin v-if="innerSpin" size="large" fix></Spin>
			<Form label-position="top" ref="approveModel" :model="approveModel">
				<Row :gutter="16">
					<Col span="6">
					<FormItem label="审核状态:" prop="approveStatus">
						<RadioGroup v-model="approveModel.approveStatus" type="button">
							<Radio :key="1" :label="1">审核通过</Radio>
							<Radio :key="2" :label="2">审核不通过</Radio>
						</RadioGroup>
					</FormItem>
					</Col>
					<Col span="24">
					<FormItem label="审核备注:" prop="approveRemark">
						<Input v-model="approveModel.approveRemark" type="textarea" :row="5"></Input>
					</FormItem>
					</Col>
				</Row>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="onSaveApprove">确认</Button>
				<Button type="error" @click="onCloseApproveModel">取消</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
import SearchCard from "@/components/searchCard/searchCard.vue";
import search from "@/libs/search";
import StandPaginationTable from "@/components/standard-pagination-table/StandPaginationTable";
import { dateTimeRender } from "@/libs/tableRowTimeRender";
import DecimalInput from '@/components/number-input/decimal-input';
import IntegerInput from '@/components/number-input/integer-input';
import { numberToFixed, numberToFixedString } from '@/components/number-input/display-format';
import {
    getCompensationList,
    saveCompensation,
    getSaleOrderDetailByCode,
    cancelCompensation,
    onSaveApproveResult
} from "@/api/modules/sale-management/sale-approve"; 
import {
    DOWNLOAD_SERVER
} from '@/api/modules/files';
import { getPreSaleOrderList, getPreSaleOrderDetail } from "@/api/modules/preSale-management/preSale-order";
import { COMPENSATION_TYPE_OPTIONS, COMPENSATION_PERSON_OPTIONS, getStatusOptions, getApproveStatusOptions, approveStatusFormat } from './compensation-type';
import {
    singleImageUploadRender
} from '@/libs/tableRowImageRender';
import { FILE_SERVER, UPLOAD_FILE_API } from '@/api/modules/files';
import SingleFileUploadWithName from '@/components/single-file-upload-with-name/SingleFileUploadWithName';
import FileUpload from "@/components/file-upload/file-upload-multi";
import { productQuantityIsRoundedMixin } from "@/view/mixins/ProductQuantityIsRounded.js";
export default {
    name: "CompensationList",
    components: {
        FileUpload,
        StandPaginationTable,
        SearchCard,
        SingleFileUploadWithName
    },
    mixins: [productQuantityIsRoundedMixin],
    data() {
        return {
            timer: '',
            mode:'add',
            cancelModel:{
                show:false,
                compensationRecordUuid:'',
                cancelReason:''
            },
            canAdd:false,
            isShowOrNot:false,
            userType:'F',
            COMPENSATION_TYPE_OPTIONS,
            COMPENSATION_PERSON_OPTIONS,
            innerSpin: false,
            mainTable: {
                columns: [
                    // { title: "#", key: "index", width: 60, align: "center" },
                    { title: "退款单号", key: "compensationRecordCode", width: 180, align: "center" },
                    { title: "关联发货单号", key: "compensationRecordRelateRecordCode", width: 180, align: "center" },
                    { title: "退款类型", key: "compensationRecordType", align: "center" },
                    { title: "退款方", key: "compensationRecordPayerName", align: "center" },
                    { title: "被退款方会员号", key: "payeeUserName", align: "center" },
                    { title: "被退款方", key: "compensationRecordPayeeName", align: "center" },
                    { title: "退款金额", key: "compensationRecordTotalValue", align: "center",
                        render: (h, params) => {
					    return h('div', [
					        h('span', {}, params.row.compensationRecordTotalValue.toFixed(2))
					    ]);
                        } },
                    { title: "退货总量", key: "compensationTotalProductCount", align: "center" },
                    { title: "客户经理", key: "userCustomerManagerName", align: "center" },
                    { title: "经办", key: "compensationRecordOperatorName", align: "center" },
                    {
                        title: "创建时间",
                        key: "compensationRecordCreatedAt",
                        align: "center",
                        render: (h, params) =>
                            dateTimeRender(h, params.row.compensationRecordCreatedAt)
                    },
                    { title: "状态", key: "status", align: "center" },
                    { title: "审核人", key: "approveUserPersonName", align: "center" },
                    { title: "审核状态", key: "approveStatus", align: "center",
                        render: (h, params) => {
					    return h('div', [
					        h('span', {}, approveStatusFormat(params.row.approveStatus))
					    ]);
                        }
                    },
                    {
                        title: '操作',
                        key: 'withDrawAction',
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.withDrawAction === -1) {
								 return '';
                            }
                            else{
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style: {},
                                        on: {
                                            click: () => {
                                                this.onShowCompensatin(params.row);
                                            }
                                        }
                                    }, '查看'),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style:{
                                            display: (this.$checkAccessArray(['B'])&&params.row.approveStatus==0)? 'inline' : 'none'
                                        },
                                        on: {
                                            click: () => {
                                                this.approveOrder(params.row);
                                            }
                                        }
                                    }, '审核'),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style:{
                                            display: (this.$checkAccessArray(['B', 'C', 'S'])&&params.row.status!='撤销'&&params.row.approveStatus==1)? 'inline' : 'none'
                                        },
                                        on: {
                                            click: () => {
                                                this.cancleOrder(params.row.compensationRecordUuid);
                                            }
                                        }
                                    }, '撤销')
                                ]);
                            }
                        }
                    }
                ],
                data: [],
                sarchCardShow: true,
                searchForm: [
                    { label: "退款单号", type: "Input", value: "", name: "compensationRecordCode", sql: "like" },
                    { label: "发货单号", type: "Input", value: "", name: "compensationRecordRelateRecordCode", sql: "like" },
                    { label: '创建时间', type: 'Daterange', value: '', name: 'compensationRecordCreatedAt', sql: 'dateBetween' },
                    { label: "退款方", type: "Input", value: "", name: "compensationRecordPayerName", sql: "like" },
                    { label: "被退款方", type: "Input", value: "", name: "compensationRecordPayeeName", sql: "like" },
                    { label: "经办", type: "Input", value: "", name: "compensationRecordOperatorName", sql: "like" },
                    {
					    label: '退款单状态',
					    type: 'Select',
					    value: [],
					    name: 'status',
					    sql: 'in',
					    options: getStatusOptions()
                    },
                    {
					    label: '退款类型',
					    type: 'Select',
					    value: [],
					    name: 'compensationRecordType',
					    sql: 'in',
					    options: [{ key: '品质', value: '品质' }, { key: '数量', value: '数量' }, { key: '品种', value: '品种' }, { key: '其他', value: '其他' }, { key: '客户投诉', value: '客户投诉' }, { key: '苗场违约', value: '苗场违约' }]
                    },
                    { label: '小类', type: 'Input', value: '', name: 'subCategoryName', sql: 'like' },
                    { label: '品种', type: 'Input', value: '', name: 'productName', sql: 'like' },
                    {
					    label: '审核状态',
					    type: 'Select',
					    value: [],
					    name: 'approveStatus',
					    sql: 'in',
					    options: getApproveStatusOptions()
                    }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            },
            productTable: {
                columns: [
                    { title: "编号", key: "productCode", align: "center" },
                    { title: "品名", key: "productName", align: "center" },
                    { title: "批次", key: "productBatchCode", align: "center" },
                    { title: "定单价格", key: "productPrice", align: "center" },
                    { title: "定单数量", key: "productQuantity", align: "center" },
                    {
                        title: "退款价格", key: "compensationDetailProductPrice", align: "center",
                        render: (h, params) => {
                            return h(DecimalInput, {
                                props: {
                                    value: params.row.compensationDetailProductPrice,
                                    precision: 4,
                                    max: this.productTable.data[params.index].productPrice>0?this.productTable.data[params.index].productPrice:0
                                },
                                on: {
                                    change: newVal => {									
                                        if(newVal<=0||newVal <= this.productTable.data[params.index].productPrice){
                                            this.productTable.data[params.index].compensationDetailProductPrice = newVal;
                                        }
                                        else{
                                            this.productTable.data[params.index].compensationDetailProductPrice = this.productTable.data[params.index].productPrice;
                                        }
                                        params.row.compensationDetailProductPrice=this.productTable.data[params.index].compensationDetailProductPrice;
                                        this.productTable.data[params.index].compensationDetailProductValue = this.productTable.data[params.index].compensationDetailProductPrice * this.productTable.data[params.index].compensationDetailProductCount;
                                        this.calculateTotalValue();
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: "退款数量", key: "compensationDetailProductCount", align: "center",
                        render: (h, params) => {
                            return h(DecimalInput, {
                                props: {
                                    value: params.row.compensationDetailProductCount,
                                    precision:this.getUnitisRounded(params.row.depositBillDetailProductUnit),
                                    max: this.productTable.data[params.index].productQuantity
                                },
                                on: {
                                    change: newVal => {
                                        if(newVal <= this.productTable.data[params.index].productQuantity){
                                            this.productTable.data[params.index].compensationDetailProductCount = newVal;
								
                                        }
                                        else{
                                            this.productTable.data[params.index].compensationDetailProductCount = this.productTable.data[params.index].productQuantity;
                                        }
                                        params.row.compensationDetailProductCount=this.productTable.data[params.index].compensationDetailProductCount;
                                        this.productTable.data[params.index].compensationDetailProductValue = this.productTable.data[params.index].compensationDetailProductPrice * this.productTable.data[params.index].compensationDetailProductCount;
                                        this.calculateTotalValue();
                                    }
                                }
                            });
                        }
                    },
                    { title: "退款金额", key: "compensationDetailProductValue", align: "center",
                        render: (h, params) => { 
                            if(this.compenstationModal.isCreated){
                                return h('span', (params.row.compensationDetailProductCount*params.row.compensationDetailProductPrice).toFixed(2));	
                            }
                            else{
                                return h('span', Number(params.row.compensationDetailProductValue).toFixed(2));	
                            }						 			 
                        }
                    }
                ],
                data: [],
                loading: false,
                tableSearch: search.getSearchParams()
            },
            orderList: [],
            compenstationModal: {
                show: false,
                compensationRecordRelateRecordCode: '',
                compensationRecordPayerType: '',
                compensationRecordPayeeType: '',
                compensationRecordUuid: '',
                compensationRecordCode: '',
                compensationRecordRelateRecordUuid: '',
                userPersonName: '',
                totalOrderCost: 0,
                status:'正常',
                cancelReason:'',
                compensationRecordType: '',
                compensationDetailModels: [],
                complains:[],
                totalValue: 0,
                voucherFile:'',
                remark:'',
                isCreated:false
            },
            //审核退款单
            approveModel:{
                show:false,
                compensationRecordUuid:'',
                approveStatus:1,
                approveRemark:''
            },
            ruleValidate:{
                compensationRecordType:[
                    { required: true, message: '请选择退款类型', trigger: 'blur' }
                ],
			    remark:[
                    { required: true, message: '备注不能为空', trigger: 'blur' }
                ],
                voucherFile:[
                    { required: true, message: '凭证不能为空', trigger: 'blur' }
                ]
            },
            onExportShow:false,
            onExportType:'明细导出'
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        numberToFixed,
        init() {
            this.getMyCompensationList();
        },
        cancleOrder(compensationRecordUuid){
            this.cancelModel.compensationRecordUuid=compensationRecordUuid;
            this.cancelModel.show=true;
        },
        onCancelSave(){
            if(!this.cancelModel.compensationRecordUuid){
                this.$Message.error("退款单ID不能为空！");
                return;
            }
            if(!this.cancelModel.cancelReason){
                this.$Message.error("撤销原因不能为空！");
                return;
            }
            this.innerSpin = true;
            cancelCompensation(this.cancelModel).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '撤销成功',
                        onOk: () => {
                            this.cancelModel.compensationRecordUuid="";
                            this.cancelModel.cancelReason="";
                            this.cancelModel.show=false;
                            this.init();
                        }
                    });
                }
                else{
                    this.$Message.error(res.message);
                }
            });
        },
        onClose(){
            this.cancelModel.compensationRecordUuid="";
            this.cancelModel.cancelReason="";
            this.cancelModel.show=false;
        },
        calculateTotalValue() { 
            this.compenstationModal.totalValue = this.productTable.data.map(e => {
                return e.compensationDetailProductValue;
            }).reduce((total, num) => {
                return Number(total) + Number(num);
            }, 0);
        },
        onCompesationCreate() {
            this.timer = new Date().getTime();
            this.canAdd=true;
            this.compenstationModal.compensationRecordPayerType="seedfarm";
            this.compenstationModal.compensationRecordPayeeType="customer";
            this.compenstationModal.compensationRecordUuid = '';
            this.compenstationModal.compensationRecordCode = '';
            this.compenstationModal.compensationRecordRelateRecordCode ='';
            this.compenstationModal.compensationRecordRelateRecordUuid = '';
            this.compenstationModal.userPersonName = '';
            this.compenstationModal.totalOrderCost = 0;
            this.compenstationModal.status = '正常';
            this.compenstationModal.cancelReason= '';
            this.compenstationModal.voucherFile = '';
            this.compenstationModal.remark = '';
            this.compenstationModal.compensationDetailModels = [];
            this.compenstationModal.complains = [];
            this.productTable.data = [];
            this.compenstationModal.show = true;
            this.compenstationModal.isCreated = true;
        },
        onShowCompensatin(row) {
            this.timer = new Date().getTime();
            this.canAdd=false;
            Object.assign(this.compenstationModal, row);
            this.compenstationModal.status=this.compenstationModal.status==null?"正常":this.compenstationModal.status;
            this.compenstationModal.compensationRecordPayerType="seedfarm";
            this.compenstationModal.compensationRecordPayeeType="customer";
            this.compenstationModal.complains = [];
            this.compenstationModal.show = true;
            this.compenstationModal.isCreated = false;
            this.onSearchOrder(0);
        },
        onCompensationSave() {
            if(!this.compenstationModal.compensationRecordType){
                this.$Modal.error({ title: '请选择退款类型！', content: '' });
                return;
            }
			    if(!this.compenstationModal.voucherFile){
			    	this.$Modal.error({ title: '请上传凭证，凭证不能为空！', content: '' });
			    	return;
			    }
				    if(!this.compenstationModal.remark){
			    	this.$Modal.error({ title: '请填写备注，备注不能为空！', content: '' });
			    	return;
			    }
            let productList = this.productTable.data.filter(p => {
                return p.compensationDetailProductCount > 0;
            });
            if (productList.length === 0) {
                this.$Modal.error({ title: '必须填写商品退款数量', content: '' });
                return;
            }
            if (productList.find(e => {
                return e.compensationDetailProductPrice < 0;
            })) {
                this.$Modal.error({ title: '填写的商品退款金额不能少于0', content: '' });
                return;
            }

            let data = {
                compensationRecordUuid: this.compenstationModal.compensationRecordUuid,
                compensationRecordRelateRecordUuid: this.compenstationModal.compensationRecordRelateRecordUuid,
                compensationRecordType: this.compenstationModal.compensationRecordType,
                compensationRecordPayerType: this.compenstationModal.compensationRecordPayerType,
                compensationRecordPayeeType: this.compenstationModal.compensationRecordPayeeType,
                voucherFile:this.compenstationModal.voucherFile,
                remark:this.compenstationModal.remark,
                details: productList.map(e => {
                    return {
                        compensationDetailRelateDetailUuid: e.detailUuid,
                        compensationDetailProductUuid: e.productUuid,
                        compensationDetailProductPrice: e.compensationDetailProductPrice,
                        compensationDetailProductCount: e.compensationDetailProductCount
                    };
                })
            };
            this.innerSpin = true;
            saveCompensation(data).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '保存成功',
                        onOk: () => {
                            this.compenstationModal.show = false;
                            this.init();
                        }
                    });
                }
            });

        },
        onCompensationcancel(){
            this.compenstationModal.compensationRecordPayerType='';
            this.compenstationModal.compensationRecordPayeeType='';
            this.compenstationModal.compensationRecordUuid='';
            this.compenstationModal.compensationRecordCode='';
            this.compenstationModal.compensationRecordRelateRecordUuid='';
            this.compenstationModal.userPersonName='';
            this.compenstationModal.totalOrderCost=0;
            this.compenstationModal.compensationRecordType='';
            this.compenstationModal.compensationDetailModels= [];
            this.compenstationModal.complains= [];
            this.compenstationModal.totalValue=0;
            this.compenstationModal.voucherFile='';
            this.compenstationModal.remark='';
            this.productTable.data = [];
            this.compenstationModal.show = false;
        },
        onSearchOrder(isCreatedInput) {
            if (this.compenstationModal.compensationRecordRelateRecordCode) {
                this.productTable.loading = true;
			  let isCreated=isCreatedInput==1?1:0;
                getSaleOrderDetailByCode({ orderCode: this.compenstationModal.compensationRecordRelateRecordCode, isCreated }).then(res => {
                    this.productTable.loading = false;
                    if (res.code === 0) {
                        let preSaleDeliveryRecord = res.data.orderDetail.preSaleDeliveryRecord;
                        let preSaleDeliveryDetails = res.data.orderDetail.preSaleDeliveryDetails;
                        this.compenstationModal.userPersonName = preSaleDeliveryRecord.userPersonName;
                        this.compenstationModal.totalOrderCost = preSaleDeliveryRecord.preSaleDeliveryRecordTotalCost;
                        this.compenstationModal.compensationRecordRelateRecordUuid = preSaleDeliveryRecord.preSaleDeliveryRecordUuid;
                        this.productTable.data = preSaleDeliveryDetails;
                        this.productTable.data.forEach(e => {
                            e.detailUuid = e.preSaleDeliveryDetailUuid;
                            e.productCode = e.productCode;
                            e.productName = e.productName;
                            e.productPrice = e.preSaleDeliveryDetailActProductPrice;
                            e.productQuantity = e.preSaleDeliveryDetailQuantity;
                            e.productUuid = e.preSaleDeliveryDetailRelateProductUuid;
			
                            let detail = this.compenstationModal.compensationDetailModels.find(d => {
                                return d.compensationDetailProductUuid === e.productUuid;
                            });
                            if (detail) {
                                e.compensationDetailProductPrice = detail.compensationDetailProductPrice;
                                e.compensationDetailProductCount = detail.compensationDetailProductCount;
                                e.compensationDetailProductValue = (detail.compensationDetailProductPrice * 1000 * detail.compensationDetailProductCount / 1000).toFixed(4);
                            }
                            else {
                                e.compensationDetailProductPrice = e.productPrice;
                                e.compensationDetailProductCount = 0;
                                e.compensationDetailProductValue = 0;
                            } 
                        });
			
                        this.calculateTotalValue();
                        this.compenstationModal.complains=res.data.complains;
                    }
                    else{
                        this.$Message.error(res.message);					
                    }
                });
            }
        },
        onUserTypeChage(){
            this.getMyCompensationList();
        },
        getMyCompensationList(reset = false) {
            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            if (this.userType) {
			    search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "memberType");
			    this.mainTable.tableSearch.filters.enable = true;
			    this.mainTable.tableSearch.filters.conditions.push({
			        name: 'memberType',
			        type: 'eq',
			        value: this.userType
			    });
            }
            this.mainTable.loading = true;
            getCompensationList(this.mainTable.tableSearch).then(res => {
                this.mainTable.loading = false;
                if (res.code === 0) {
                    let totalCount = 0;
                    let index = 1;
                    this.mainTable.data = res.data.records;
                    this.isShowOrNot=res.data.isShowOrNot;
                    search.globalSetFilterRecordCount(
                        this.mainTable.tableSearch,
                        res.data.filterRecordCount
                    );

                    this.mainTable.data.forEach(e => {
                        e.index = index++;
					    totalCount += e.compensationRecordTotalValue;
                    });

                    this.mainTable.data.push({
					    compensationRecordTotalValue: parseFloat(numberToFixedString(totalCount, 4)),
					    compensationRecordPayeeName: '合计',
                        withDrawAction: -1
                    });
                }
            });
        },
        onExport() {
            const queryData = Object.assign(this.mainTable.tableSearch, {
                needExport: true,
                exportType:this.onExportType=='明细导出'?1:2
            });
            this.mainTable.tableSearch.limit.enable = false;
            this.mainTable.loading = true;
            getCompensationList(queryData).then(res => {
                this.mainTable.loading = false;
                if (res.code === 0) {
                    //  window.open(FILE_SERVER + res.data.exportFileName, "_blank");
                    let url = DOWNLOAD_SERVER + res.data.exportFileName;
                    this.$downLoadFile(url);
                }
            }).catch(() => {
                this.mainTable.loading = false;
            });
        },
        //审核退款单
        approveOrder(row){
            this.approveModel.compensationRecordUuid=row.compensationRecordUuid;
            this.approveModel.show=true;
        },
        //取消审核
        onCloseApproveModel(){
            this.approveModel.show=false;
        },
        //保存审核
        onSaveApprove(){
            let data={
                compensationRecordUuid:this.approveModel.compensationRecordUuid,
                approveStatus:this.approveModel.approveStatus,
                approveRemark:this.approveModel.approveRemark
            };
            this.innerSpin = true;
            onSaveApproveResult(data).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
					 this.$Message.success('保存成功!');
					 this.approveModel.show=false;
					 this.getMyCompensationList();
                }
            });
        }
    }
};
</script>

<style scoped></style>
